import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyAdjusterImagesQueryParamsType,
  GetBodyDamagedAdjusterImagesQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImages/getBodyDamagedAdjusterImagesQuery.type';

export const getBodyDamagedAdjusterImagesQueryFunction = (
  params: GetBodyAdjusterImagesQueryParamsType,
): Promise<GetBodyDamagedAdjusterImagesQueryResponseType> => {
  return fetchApi.get(`body/reports/${params?.id}/images/adjuster/vehicle/`, {
    params,
  });
};
